<template>
  <div class="home">
    <el-main>
      <el-carousel indicator-position="outside" class="nofull">
        <el-carousel-item
          v-for="(slide, index) in slider"
          :key="index"
          :style="{
            backgroundImage: 'url(' + slide.image_url + ')',
            backgroundSize: 'cover',
          }"
        >
          <div class="sliderTitleBg">
            <a :href="slide.link_url" target="_blank"
              ><h3>{{ slide.title }}</h3></a
            >
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-row class="nofull">
        <div class="row_header">
          <div class="row_title fl">近期会议</div>
          <el-link class="fr" type="primary" @click="more">更多</el-link>
        </div>
        <el-row :gutter="40">
          <el-col :span="6" v-for="(item, index) in eventList" :key="index">
            <el-card :body-style="{ padding: '0px' }">
              <div class="card_state">
                <div :style="{ background: item.signUpStateColor }">
                  {{ item.signUpState }}
                </div>
                <div :style="{ background: item.submitStateColor }">
                  {{ item.submitState }}
                </div>
              </div>
              <router-link
                :to="{
                  path: '/eventDetail',
                  query: { eventId: item.forum_id },
                }"
              >
                <el-image
                  :src="
                    '/forum-pub-api/v1/minio/getFile?file_url=' + item.image_url
                  "
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <div class="errText">{{ item.name }}</div>
                    <img
                      class="el-image__inner"
                      style="object-fit: cover"
                      src="../assets/errbg.jpg"
                    />
                  </div>
                </el-image>
              </router-link>
              <div class="card_content">
                <router-link
                  class="card_title"
                  :to="{
                    path: '/eventDetail',
                    query: { eventId: item.forum_id },
                  }"
                >
                  {{ item.name }}
                </router-link>
                <div class="card_org">
                  {{ orgLabel }}：<span>{{ item.setting_json.orgnizer }}</span>
                </div>
                <!-- <div class="abstract">{{ item.description }}</div> -->
                <div class="time">
                  承办单位：<span>{{ item.setting_json.undertaker }}</span>
                </div>
                <time class="time"
                  >{{ sDate }}：<span>{{
                    changetoLocaleString(item.start_time)
                  }}</span></time
                >
                <time class="time"
                  >{{ eDate }}：<span>{{
                    changetoLocaleString(item.end_time)
                  }}</span></time
                >
                <!--
                                <div class="bottom clearfix" v-for="(obj, index) in [toJson(item.setting_json)]" :key="index">
                                    <div class="card_org">{{ orgLabel }}：<span>{{ obj.orgnizer }}</span></div>
                                    <time class="time">{{ sDate }}：<span>{{ item.start_time }}</span></time>
                                    <time class="time">{{ eDate }}：<span>{{ item.end_time }}</span></time>
                                </div>
                                -->
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import { getHomeSlider } from '@/apis/homeSlider.js';
import { getEvents } from '@/apis/events.js';
export default {
  inject: ['reload'],
  name: 'Home',
  mounted() {
    this.reload();
    this.$emit('activeIndex', '1');
    this.$emit('pageClass', 'home');
    getHomeSlider()
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.slider = res.data.data.items
              .sort((a, b) => a.sort_order - b.sort_order)
              .map((item) => ({
                ...item,
                image_url: this.getImageUrl(item.image_url),
              }));
          } else {
            this.$message.error(res.data.message);
          }
          console.log(res.data);
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    getEvents({
      sort_order: 'desc',
      page: 1,
      page_size: 12,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.eventList = res.data.data.items;
          } else {
            this.$message.error(res.data.message);
          }
          console.log(res.data);
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      sliderNum: '3',
      slider: [
        /*{
                        title:'标题1',
                        image_url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        link_url:'#',
                    },
                    {
                        title:'标题1',
                        image_url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        link_url:'#',
                    },
                    {
                        title:'标题1',
                        image_url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        link_url:'#',
                    },*/
      ],

      orgLabel: '主办单位',
      sDate: '开始时间',
      eDate: '结束时间',
      eventList: [
        /*{
                        eventImgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        eventTitle:'北京经济论坛2020',
                        abstract: '北京经济论坛简介北京经济论坛简介北京经济论坛简介北京经济论坛北京经济论坛',
                        orgName: '中国经济学年会',
                        startDate: '2020–06-18 @ 08:00',
                        endDate: '2020–06-28 @ 08:00',
                        stateNum: '1',
                        signUpState: '',
                        signUpStateColor: '',
                        submitState: '投稿中',
                        submitStateColor: '#67c23a',
                    },
                    {
                        eventImgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        eventTitle:'北京经济论坛2019',
                        abstract: '北京经济论坛简介北京经济论坛简介北京经济论坛简介北京经济论坛北京经济论坛',
                        orgName: '中国经济学年会',
                        startDate: '2020–06-18 @ 08:00',
                        endDate: '2020–06-28 @ 08:00',
                        stateNum: '2',
                        signUpState: '报名中',
                        signUpStateColor: '#67c23a',
                        submitState: '投稿截止',
                        submitStateColor: 'rgba(100,100,100,0.5)',
                    },
                    {
                        eventImgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        eventTitle:'北京经济论坛2018',
                        abstract: '北京经济论坛简介北京经济论坛简介北京经济论坛简介北京经济论坛北京经济论坛',
                        orgName: '中国经济学年会',
                        startDate: '2020–06-18 @ 08:00',
                        endDate: '2020–06-28 @ 08:00',
                        stateNum: '3',
                        signUpState: '报名截止',
                        signUpStateColor: '#e6a23c',
                        submitState: '投稿截止',
                        submitStateColor: 'rgba(100,100,100,0.5)',
                    },
                    {
                        eventImgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        eventTitle:'北京经济论坛2017',
                        abstract: '北京经济论坛简介北京经济论坛简介北京经济论坛简介北京经济论坛北京经济论坛',
                        orgName: '中国经济学年会',
                        startDate: '2020–06-18 @ 08:00',
                        endDate: '2020–06-28 @ 08:00',
                        stateNum: '4',
                        signUpState: '进行中',
                        signUpStateColor: '#409eff',
                        submitState: '投稿截止',
                        submitStateColor: 'rgba(100,100,100,0.5)',
                    },
                    {
                        eventImgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        eventTitle:'北京经济论坛2016',
                        abstract: '北京经济论坛简介北京经济论坛简介北京经济论坛简介北京经济论坛北京经济论坛',
                        orgName: '中国经济学年会',
                        startDate: '2016–06-18 @ 08:00',
                        endDate: '2016–06-28 @ 08:00',
                        stateNum: '4',
                        signUpState: '已完结',
                        signUpStateColor: 'rgba(100,100,100,0.5)',
                        submitState: '',
                        submitStateColor: '',
                    },*/
      ],
    };
  },
  methods: {
    changetoLocaleString(str) {
      if (str) {
        // let localeTime = new Date(str);
        // return this.common.dateFormat("YYYY/mm/dd", localeTime)
        return this.$moment(str).format('YYYY-MM-DD');
      } else {
        return str;
      }
    },
    more() {
      this.$router.push('/events');
    },
    toJson(str) {
      let jsonToObj = JSON.parse(str);
      // console.log(jsonToObj);
      return jsonToObj;
    },
    getImageUrl(filename) {
      if (!filename) return '';
      return filename.startsWith('http')
        ? filename
        : `/forum-pub-api/v1/minio/getFile?file_url=${encodeURI(filename)}`;
    },
  },
  computed: {},
};
</script>

<style scoped></style>
